import { forwardRef, useContext, useState, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';
import { ConfigProvider, Form } from "antd";

import { Typography, Button, Input } from 'mobily-ui-library/lib';
import { GlobalContext } from '../../../context/GlobalContext';

import './DeviceLogin.scss';
import HeaderNavigation from '../HeaderNavigation/HeaderNavigation';

interface Props {
    handleSubmit: (text: string, id: string) => void;
    handleHeaderCancel: () => void;
}

const DeviceLogin = forwardRef((props: Props, ref: any) => {
    const { handleSubmit, handleHeaderCancel } = props;
    const { state }: any = useContext(GlobalContext);
    const { rtl, deviceFlow } = state;

    const { t } = useTranslation();
    const [form] = Form.useForm();

    const direction = rtl ? 'rtl' : 'ltr';

    const [mobileValid, setMobileValid] = useState(false);
    const [mobileNumber, setMobileNumber] = useState('05');
    const [mobileNumberColor, setMobileNumberColor] = useState('blue');
    const [idCheck, setIdCheck] = useState(false);
    const [userID, setUserID] = useState('');

    const handleMobileNumber = (e: any) => {
        const value = e.target.value;
        let newValue = value;
        if (newValue.indexOf('05') != 0) {
            newValue = '05'
        }
        form.setFieldsValue({
            mobileNumber: newValue
        });
        setMobileNumber(newValue);
        const regex = /^((05)([0-9]{8}))$/;
        if (regex.test(value)) {
            setMobileValid(true);
        } else {
            setMobileValid(false);
        }
    }

    const focusHandelMobileNumber = () => {
        if (!mobileNumber) {
            form.setFieldsValue({
                mobileNumber: '05'
            });
        }
        setMobileNumberColor('blue');
    }

    const focusOutHandelMobileNumber = () => {
        if (mobileNumber.length > 2) {
            const pattern = /^(((05)(5|0|3|6|4|9|1|8|7|2)([0-9]{7})))$/
            const result = pattern.test(mobileNumber);
            if (result) {
                setMobileNumberColor('blue');
            }
            else {
                setMobileNumberColor('red');
            }
        } else {
            setMobileNumberColor('blue');
        }
    }

    const lastDigitChecksumForId = (digits: any) => {
        var ln = digits.length;

        if (ln !== 9) {
            return -1;
        }

        var bits = digits;
        var total = 0;
        for (var i = 0; i < 9; i += 2) {
            var v = parseInt(bits[i]);

            if (v < 5) {
                total = total + v * 2;
            } else {
                total = total + (2 * v - 9);
            }
        }
        // now add the even digits to this total
        for (var j = 1; j < 9; j += 2) {
            var w = parseInt(bits[j]);
            total = total + w;
        }
        // now take the ones digit of this total, called the MR digit...
        var MR = total % 10;

        // ...and return the last digit as:
        if (MR === 0) {
            return 0;
        } else {
            return 10 - MR;
        }
    };

    const idCheckSum = (custId: any) => {
        var lastDigit = 0;
        var lastDigitChks = 0;
        lastDigit = parseInt(custId[9]);

        lastDigitChks = lastDigitChecksumForId(custId.substring(0, 9));

        if (lastDigit !== lastDigitChks) {
            return false;
        }
        return true;
    };

    const handleUserId = (e: any) => {
        var value = e.target.value.replace(/\s/g, '');
        var newValue = '';
        for (var i = 0; i < value.length; i++) {
            if (i % 2 == 0 && i > 0) newValue = newValue.concat(' ');
            newValue = newValue.concat(value[i]);
        }

        form.setFieldsValue({
            userID: newValue
        });
        setUserID(value);
        if (idCheckSum(value)) {
            setIdCheck(true)
        } else {
            setIdCheck(false)
            form.setFields([
                {
                    name: "userID",
                    errors: [t("not_a_valid_id")],
                },
            ]);
        }
        const pattern = /^(((1)([0-9]){9})||((2)([0-9]){9}))$/
        const result = pattern.test(value);
        if (result) {
            console.log(result)
        } else {
            setIdCheck(false)
            form.setFields([
                {
                    name: "userID",
                    errors: [t("not_a_valid_id")],
                },
            ]);
        }
    }

    useImperativeHandle(ref, () => ({
        removeMobileNumber() {
            let newValue = '';
            if (newValue.indexOf('05') != 0) {
                newValue = '05'
            }
            form.setFieldsValue({
                mobileNumber: newValue
            });
            setMobileNumber(newValue);
        }
    }));

    return (
        <>
            <HeaderNavigation
                rtl={rtl}
                percent={25}
                showBackArrow={false}
                handleHeaderCancel={handleHeaderCancel}
            />

            <section className='SubsidyLogin__Section'>
                <div className='SL__headerText'>
                    <Typography id="sl-heading" rtl={rtl} className='SL__heading'>{deviceFlow === 'subsidy' ? t('Check_device_subsidy') : t('Check_device_instalment')}</Typography>
                    <Typography id="sl-Subheading" rtl={rtl} className='SL__subHeading'>{deviceFlow === 'subsidy' ? t('Check_device_subsidy_subtitle') : t('we_need_to_check_if_plan_is_eligible_for_installment')}</Typography>
                </div>

                <ConfigProvider direction={direction}>
                    <Form form={form} className={rtl ? "SL__Form SL__right" : "SL__Form"} onFinish={() => handleSubmit(mobileNumber, userID)}>
                        <Form.Item
                            hasFeedback
                            name='mobileNumber'
                            initialValue={mobileNumber}
                            className={`loginType_mobileNum_text_color-${mobileNumberColor}`}
                            rules={[
                                { required: true, message: t('Receiver_Phone_Number_is_Missing') },
                                {
                                    message: t('Not_a_Valid_Phone_Number'),
                                    pattern: /^((05)([0-9]{8}))$/
                                }
                            ]}
                        >
                            <Input
                                type="text"
                                maxLength={10}
                                value={mobileNumber}
                                id="mobilyNumber-input"
                                className="SL__FormInput"
                                headingleft={t('Enter_number')}
                                labelleft={deviceFlow === 'subsidy' ? t('Subscribed_to_Postpaid') : t('this_line_must_subscribed_to_postPaid_for_installment')}

                                onChange={handleMobileNumber}
                                onFocus={focusHandelMobileNumber}
                                onBlur={focusOutHandelMobileNumber}
                            />
                        </Form.Item>
                        <Form.Item
                            initialValue={userID}
                            hasFeedback
                            name='userID'
                            className='userId__inputField'
                            rules={[
                                { required: true, message: t("not_a_valid_id") },
                                {
                                    message: t("not_a_valid_id"),
                                    pattern: idCheck ? /^((1|2)([0-9\s]){13})$/ : /^((1|2)([0-9\s]){18})$/,
                                },
                            ]}
                        >
                            <Input
                                type="text"
                                id="userID-input"
                                name={userID}
                                value={userID}
                                className="DCL__FormInput userId__inputAnt SL__FormInput"
                                placeholder={'XX XX XX XX XX'}
                                headingleft={t("ID_number")}
                                labelleft={t('ID_SubLabel')}
                                onChange={handleUserId}
                                maxLength={14}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button
                                rtl={rtl}
                                id="login-button"
                                className="SL_FormBtn"
                                htmlType={'submit'}
                                variant={mobileValid && idCheck ? "default" : "disabled"}
                            >
                                {t('Continue')}
                            </Button>
                        </Form.Item>
                    </Form>
                </ConfigProvider>
            </section>
        </>
    )
})

export default DeviceLogin